import styled from '@emotion/styled'

export const NavIconWrapper = styled.div({
  width: 40,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
})
